/* import __COLOCATED_TEMPLATE__ from './credit-card-application.hbs'; */
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { equal, or } from '@ember/object/computed';
import { ApplicationFlow } from '@square/dashboard-protos/models/squareup/corporate_card/resources/application_flow/application_flow';
let CreditCardApplication = (_dec = equal('args.manualReviewState', ApplicationFlow.ManualReviewInformation.State.AWAITING_DOCUMENTS), _dec2 = equal('args.manualReviewState', ApplicationFlow.ManualReviewInformation.State.AWAITING_ADDITIONAL_DOCUMENTS), _dec3 = or('isAwaitingDocuments', 'isAwaitingAdditionalDocuments'), _class = class CreditCardApplication extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "applicationRouter", _descriptor2, this);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "isAwaitingDocuments", _descriptor3, this);
    _initializerDefineProperty(this, "isAwaitingAdditionalDocuments", _descriptor4, this);
    _initializerDefineProperty(this, "shouldShowCta", _descriptor5, this);
  }
  get pillVariant() {
    return this.isAwaitingDocuments || this.isAwaitingAdditionalDocuments ? 'warning' : 'normal';
  }
  get pillText() {
    if (this.isAwaitingDocuments) {
      return this.intl.t('banking.launchpad.creditCard.applicationSection.awaitingDocuments.pill');
    } else if (this.isAwaitingAdditionalDocuments) {
      return this.intl.t('banking.launchpad.creditCard.applicationSection.awaitingAdditionalDocuments.pill');
    } else {
      return this.intl.t('banking.launchpad.creditCard.applicationSection.awaitingReview.pill');
    }
  }
  get titleText() {
    if (this.isAwaitingDocuments) {
      return this.intl.t('banking.launchpad.creditCard.applicationSection.awaitingDocuments.title');
    } else if (this.isAwaitingAdditionalDocuments) {
      return this.intl.t('banking.launchpad.creditCard.applicationSection.awaitingAdditionalDocuments.title');
    } else {
      return this.intl.t('banking.launchpad.creditCard.applicationSection.awaitingReview.title');
    }
  }
  get bodyText() {
    if (this.isAwaitingDocuments) {
      return this.intl.t('banking.launchpad.creditCard.applicationSection.awaitingDocuments.body');
    } else if (this.isAwaitingAdditionalDocuments) {
      return this.intl.t('banking.launchpad.creditCard.applicationSection.awaitingAdditionalDocuments.body');
    } else {
      return this.intl.t('banking.launchpad.creditCard.applicationSection.awaitingReview.body');
    }
  }
  get ctaText() {
    return this.isAwaitingDocuments ? this.intl.t('banking.launchpad.creditCard.applicationSection.awaitingDocuments.cta') : this.intl.t('banking.launchpad.creditCard.applicationSection.awaitingAdditionalDocuments.cta');
  }
  handleRowClick() {
    // The row should only be interactive if the cta is not shown.
    if (!this.shouldShowCta) {
      this.goToCreditCardApplication();
    }
  }
  goToCreditCardApplication() {
    this.applicationRouter.transitionToExternal('credit-card-manual-review');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "applicationRouter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isAwaitingDocuments", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isAwaitingAdditionalDocuments", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "shouldShowCta", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "handleRowClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleRowClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToCreditCardApplication", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToCreditCardApplication"), _class.prototype), _class);
export { CreditCardApplication as default };